"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSvg = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = require("styled-components");
var fullSize = styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n\n  &.defaultStyle {\n    display: inline;\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n\n  &.defaultStyle {\n    display: inline;\n  }\n"])));
exports.StyledSvg = styled_components_1.default.svg(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), fullSize);
var templateObject_1, templateObject_2;
//# sourceMappingURL=Icon.styled.js.map